var React = require('react');

function CheckCircle (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M84 32.6621L51.3333 76.9954L28 58.3288","stroke":"#3BB926","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M56 109.662C85.6393 109.662 109.667 85.6346 109.667 55.9953C109.667 26.356 85.6393 2.32861 56 2.32861C26.3608 2.32861 2.33337 26.356 2.33337 55.9953C2.33337 85.6346 26.3608 109.662 56 109.662Z","stroke":"#3BB926","strokeWidth":"3","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CheckCircle.defaultProps = {"width":"112","height":"112","viewBox":"0 0 112 112","fill":"none"};

module.exports = CheckCircle;

CheckCircle.default = CheckCircle;
